module.exports = __webpack_public_path__ + "static/media/heroBG2.428221ba.svg";